import {Box, Button, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import {Form, Formik} from "formik";
import ButtonCustom from "../../../shared/button-custom/ButtonCustom";
import OutlinedInputCustom from "../../../shared/outlined-input-custom/OutlinedInputCustom";
import {INIT_VALUES, notificationValidationSchema, validationSchema} from "./config";
import SettingsService, {SettingsServiceType} from "./SettingsService";
import OutlinedBoxInputCustom from "../../../shared/outlined-input-custom/OutlinedBoxInputCustom";
import SwitchIOS from "../../../shared/switch-ios/SwitchIOS";
import Colors from "../../../../utils/Colors";
import React from "react";

export default function Settings({isTeacher}: any) {
    let {
        handleOnSubmit,
        handleOnSubmitNotifications,
        expressionSettings,
        handleChangeUseFeedbackNotifications
    }: SettingsServiceType = SettingsService();

    return (
        <Grid container item xs={12} className="ac-settings" justifyContent="center">
            <Grid item xs={12} textAlign="center" pt={1} pb={4}>
                <Typography variant="h6">My Settings</Typography>
            </Grid>
            {isTeacher && expressionSettings &&
                <Formik initialValues={expressionSettings} validationSchema={notificationValidationSchema}
                        onSubmit={handleOnSubmitNotifications}>{
                    ({handleBlur, values, touched, errors, handleChange, isValid}) => (
                        <Form>
                            <Grid container item xs={12} justifyContent="center" pb={3} rowSpacing={2}>
                                <Grid item xs={12} textAlign="center">
                                    <Typography variant="h6">Notifications</Typography>
                                </Grid>
                                <Grid item xs={12} justifyContent="center">
                                    <Typography variant="body1">
                                        You can set a threshold for getting feedback from students. For example, if you
                                        set
                                        a
                                        threshold 20% for feedback “I am lost”, you will get a notification when more
                                        that
                                        20%
                                        of
                                        students pressed the button “I am lost”. Feel free to modify default
                                        settings.</Typography>
                                </Grid>
                                <Grid container item xs={12} justifyContent="start" alignItems="center">

                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "30%"
                                    }}>
                                        <Typography variant="subtitle2">No</Typography>
                                        <SwitchIOS
                                            value={expressionSettings?.useFeedbackNotifications ?? false}
                                            onChange={(e: any, checked: boolean) => handleChangeUseFeedbackNotifications(checked)}
                                            activeColor={Colors.GREEN_SOLID}
                                            deactiveColor={Colors.RED_SOLID}
                                        />
                                        <Typography variant="subtitle2">Yes</Typography>
                                    </Box>
                                    <Typography className="allow_notifications__title">Use feedback
                                        notifications.</Typography>
                                </Grid>
                                {expressionSettings?.useFeedbackNotifications &&
                                    <Grid container item xs={12}
                                          direction="column"
                                          alignContent="center" rowSpacing={2}>
                                        <Grid container item alignItems="center">
                                            <OutlinedBoxInputCustom
                                                name="lost"
                                                type="number"
                                                value={values.lost}
                                                onChange={handleChange}
                                                error={touched.lost && Boolean(errors.lost)}
                                                aria-describedby="outlined-id-helper-text"
                                                onBlur={handleBlur}
                                                className="ac-box-text-field-no-left-margin"
                                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                            <Typography variant="subtitle2">
                                                I'm Lost
                                            </Typography>
                                        </Grid>
                                        <Grid container item alignItems="center">
                                            <OutlinedBoxInputCustom
                                                placeholder="0"
                                                name="notClear"
                                                type="number"
                                                value={values.notClear}
                                                onChange={handleChange}
                                                error={touched.notClear && Boolean(errors.notClear)}
                                                onBlur={handleBlur}
                                                aria-describedby="outlined-id-helper-text"
                                                className="ac-box-text-field-no-left-margin"
                                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                            <Typography variant="subtitle2">
                                                Not Clear
                                            </Typography>
                                        </Grid>
                                        <Grid container item alignItems="center">
                                            <OutlinedBoxInputCustom
                                                placeholder="0"
                                                name="tooHard"
                                                type="number"
                                                value={values.tooHard}
                                                onChange={handleChange}
                                                error={touched.tooHard && Boolean(errors.tooHard)}
                                                onBlur={handleBlur}
                                                aria-describedby="outlined-id-helper-text"
                                                className="ac-box-text-field-no-left-margin"
                                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                            <Typography variant="subtitle2">
                                                Too Hard
                                            </Typography>
                                        </Grid>
                                        <Grid container item alignItems="center">
                                            <OutlinedBoxInputCustom
                                                placeholder="0"
                                                name="tooSimple"
                                                type="number"
                                                value={values.tooSimple}
                                                onChange={handleChange}
                                                error={touched.tooSimple && Boolean(errors.tooSimple)}
                                                onBlur={handleBlur}
                                                aria-describedby="outlined-id-helper-text"
                                                className="ac-box-text-field-no-left-margin"
                                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                            <Typography variant="subtitle2">
                                                Too Simple
                                            </Typography>
                                        </Grid>
                                        <Grid container item alignItems="center">
                                            <OutlinedBoxInputCustom
                                                placeholder="0"
                                                name="great"
                                                type="number"
                                                value={values.great}
                                                onChange={handleChange}
                                                error={touched.great && Boolean(errors.great)}
                                                onBlur={handleBlur}
                                                aria-describedby="outlined-id-helper-text"
                                                className="ac-box-text-field-no-left-margin"
                                                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                            />
                                            <Typography variant="subtitle2">
                                                Great
                                            </Typography>
                                        </Grid>

                                        <Grid container item mt={2} width="30%">
                                            {/*<Button type="submit" disabled={!(isValid)} variant="contained">Save</Button>*/}
                                            <ButtonCustom disabled={!(isValid)} type="submit" gradient="dark-purple"
                                                          label="Save" whiteBorder fontWeight="500"/>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </Form>
                    )
                }
                </Formik>
            }
            <Formik initialValues={INIT_VALUES} validationSchema={validationSchema} onSubmit={handleOnSubmit}>
                {({handleBlur, values, touched, errors, handleChange, isValid, dirty}) => (
                    <Form>
                        <Grid container item xs={12} justifyContent="center" rowSpacing={2}>
                            <Grid item xs={12} textAlign="center">
                                <Typography variant="h6">Change Password</Typography>
                            </Grid>
                            <Grid item xs={12} justifyContent="center" pb={2}>
                                <Typography variant="body1">The new password should have at least 8 characters including
                                    at least one lower and uppercase letter, and at least one number.</Typography>
                            </Grid>

                            <Grid item xs={12} justifyContent="center" alignItems="flex-start">
                                <OutlinedInputCustom
                                    placeholder="Current password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    aria-describedby="outlined-id-helper-text"
                                    error={touched.password && Boolean(errors.password)}
                                    onBlur={handleBlur}
                                    type="password"
                                    fullWidth
                                    className="ac-text-field"
                                />
                                <div className="error-text">{touched.password && Boolean(errors.password) &&
                                    <label>{errors.password}</label>}</div>
                                <OutlinedInputCustom
                                    placeholder="New password"
                                    name="newPassword"
                                    value={values.newPassword}
                                    onChange={handleChange}
                                    aria-describedby="outlined-id-helper-text"
                                    error={touched.newPassword && Boolean(errors.newPassword)}
                                    onBlur={handleBlur}
                                    type="password"
                                    fullWidth
                                    className="ac-text-field"
                                />
                                <div className="error-text">{touched.newPassword && errors.newPassword &&
                                    <label>{errors.newPassword}</label>}</div>
                                <OutlinedInputCustom
                                    placeholder="Confirm new password"
                                    name="newPasswordConfirm"
                                    value={values.newPasswordConfirm}
                                    onChange={handleChange}
                                    aria-describedby="outlined-id-helper-text"
                                    error={touched.newPasswordConfirm && Boolean(errors.newPasswordConfirm)}
                                    onBlur={handleBlur}
                                    type="password"
                                    fullWidth
                                    className="ac-text-field"
                                />
                                <div className="error-text">{touched.newPasswordConfirm && errors.newPasswordConfirm &&
                                    <label>{errors.newPasswordConfirm}</label>}</div>
                            </Grid>
                            <ButtonCustom disabled={!(isValid && dirty)} type="submit" gradient="dark-purple"
                                          label="Change" whiteBorder fontWeight="500"/>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Grid>
    );
}
